import { useEffect, useState } from "react";
import { ShortcutKeys } from "@/shared/keyboard/ShortcutKeys";
import {
  SHORTCUTS,
  inDisplayOrder,
  SHORTCUT_GROUPS,
  onShortcutsEnabledChange,
  setShortcutsEnabled,
  shortcutsEnabled
} from "@/shared/keyboard/shortcuts";
import { hasRoleAtLeast } from "@/shared/utils/roles";
import { navigationItems } from "@/shell/navigation";
import { useAppShell } from "@/shell/app-shell-context";

/**
 * Preferências → Atalhos (2026-10-16): a lista dos atalhos de teclado que a
 * pessoa tem e a chave de ligar/desligar — a mesma preferência da lista do ?
 * (um muda, o outro acompanha). Mostra só o que o papel dela alcança, pela
 * mesma regra do menu.
 */
export function ShortcutsPage() {
  const { profile } = useAppShell();
  const [enabled, setEnabled] = useState(shortcutsEnabled);
  useEffect(() => onShortcutsEnabledChange(() => setEnabled(shortcutsEnabled())), []);

  const visible = SHORTCUTS.filter(item => {
    if (!item.nav) return true;
    const nav = navigationItems.find(entry => entry.label === item.nav);
    return Boolean(nav) && (!nav?.requiresRole || hasRoleAtLeast(profile, nav.requiresRole));
  });

  return (
    <div className="ajustes-panel account-panel">
      <header className="panel-header">
        <div>
          <h2>Atalhos de teclado</h2>
          <p>Navegue pela plataforma sem tirar as mãos do teclado. Pressione ? a qualquer momento para ver esta lista.</p>
        </div>
      </header>

      <section className="panel-section">
        <h3>Ativar atalhos</h3>
        <p className="account-section-hint">
          Desligados, nenhuma tecla faz nada. Letras dentro de campos de texto nunca disparam atalho.
        </p>
        <label className="shortcuts-toggle">
          <input
            type="checkbox"
            checked={enabled}
            onChange={event => setShortcutsEnabled(event.target.checked)}
          />
          <span>Ativar atalhos de teclado</span>
        </label>
      </section>

      {SHORTCUT_GROUPS.map(group => {
        const items = inDisplayOrder(visible.filter(item => item.group === group.key));
        if (!items.length) return null;
        return (
          <section key={group.key} className={`panel-section shortcuts-list-section${enabled ? "" : " is-off"}`}>
            <h3>{group.label}</h3>
            {group.hint && (
              <p className="account-section-hint">
                {group.hint} As telas de empresa abrem na empresa em que você está ou, fora de uma, na última que você abriu.
              </p>
            )}
            <ul>
              {items.map(item => (
                <li key={item.id}>
                  <span>{item.label}</span>
                  <ShortcutKeys item={item} />
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </div>
  );
}
